import Flickity from 'flickity';
import $ from 'jquery';
import PubSub from 'pubsub-js';
var CustomWork = function(){

	var $section = $('#CustomWork');
  if ( $section.length < 1 ) return false;
	var $carousel = $section.find('.js-carousel'),
      $nav = $section.find('.js-nav'),
      $close = $section.find('.js-close'),
      navItemClass = 'js-nav-item',
      navActiveClass = 'is-active',
			flkty;


  // UI Event Listeners
  $nav.on('click', '.' + navItemClass, navClickHandler);

  $close.on('click', closeClickHandler);

  // Subscribe to PubSub Events
	PubSub.subscribe('updatelayout', updateLayout);
	updateLayout();

  function navClickHandler(event) {
    var url;
    event.preventDefault();

    // Set state of carousel
    $carousel.addClass('is-active');
    updateLayout();

    // Prevent clicks on active nav item
    if( $(this).hasClass(navActiveClass) ) return false;

    // Set State of nav item
    $nav.find('.' + navItemClass).removeClass( navActiveClass );
    $(this).addClass( navActiveClass );



    // Load URL
    url = $(this).data('url');
    loadNewCarousel( url );
  }

  function closeClickHandler() {
    $carousel.removeClass('is-active');
  }

  function loadNewCarousel( url ) {
    var ajax = $.ajax( url );
        // .done(function(data) {
        //   console.log( "success" );
        //   console.log( data );
        // })
        // .fail(function() {
        //   console.log( "error" );
        // })
        // .always(function() {
        //   console.log( "complete" );
        // });

      // // Perform other work here ...

      // // Set another completion function for the request above
      // loadUrl.always(function() {
      //   console.log( "second complete" );
      // });

    ajax.done(function(data){
      swapCarouselSlides(data);
    });
  }

  function swapCarouselSlides( data ) {
    var $slides = $(data).find('.js-slide');
    resizeCells($slides);
    flkty.remove( flkty.getCellElements() );
    flkty.insert( $slides.toArray() );
    flkty.select( 0, true, true )
  }

  function createFlickity() {
    if( flkty ) return false;
    flkty = new Flickity( $carousel[0], {
      // options
      lazyLoad: 4,
      // imagesLoaded: false,
      percentPosition: false,
      wrapAround: true,
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: false,
      watchCSS: false,
      cellSelector: '.js-slide',
      setGallerySize: false
    });

    flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
      flkty.select( cellIndex, false, false )
    });

    // Custom prev / next buttons
    $carousel.find('.js-prev').click(function(){
      flkty.previous( true );
    });

    $carousel.find('.js-next').click(function(){
      flkty.next( true );
    });
  }

	function updateLayout() {
    createFlickity();
		resizeCells();
	}

	function resizeCells($cells) {

    if( $carousel.is(":visible") === false ) return false;

    var $cells = typeof $cells !== 'undefined' ? $cells.find('.js-placeholder') : $carousel.find('.js-placeholder'),
        $ph,
        width,
        height,
        setWidth,
        carouselWidth = $carousel.width(),
        carouselHeight = $carousel.outerHeight(),
        smallPadding = 40,
        percent;

    $cells.each(function(){
      $ph = $(this);
      width = $ph.data('width');
      height = $ph.data('height');
      setWidth,
      percent = carouselHeight / height;

      // if(TransomBreakpoint.is('small')) {
      //   setWidth = carouselWidth - smallPadding;
      // } else {
      //   setWidth = width * percent;
      // }
      setWidth = width * percent;
      $ph.css({'width': setWidth });
    });

    // Reposition the carousel
    if( flkty ) {
      flkty.resize();
    }

	}

  // Helper function

  // function isModalView() {
  //   return $carousel.is(":visible") ? false : true;
  // }

} // Module

export default CustomWork();